import { Routes, Route } from "react-router-dom";

import HomeIndex from "./Components/HomePage/HomeIndex";
import AttendenceIndex from "./Components/Attendence/AttendenceIndex";
import AdminLoginIndex from "./Components/AdminLogin/AdminLoginIndex";
import GenerateBillForm from "./Components/BillGenerator/GenerateBillForm";
import BillGeneratorLogin from "./Components/BillGenerator/BillGeneratorLogin";
import NotFoundPage from "./Components/HomePage/NotFoundPage";
import IdentityVerification from "./Components/IdentityVerify/IdentityVerification";
// ✅ ADMIN
import AdminLayout from "./Components/Admin/SideBar/AdminLayout";
import Dashboard from "./Components/Admin/Pages/Dashboard";
import Attendance from "./Components/Admin/Pages/Attendance";
import Bills from "./Components/Admin/Pages/Bills";
import PendingBills from "./Components/Admin/Pages/PendingBills";
import PendingBillsList from "./Components/Admin/Pages/PendingBillsList";
import IDCards from "./Components/Admin/Pages/IDCardPortal";
import LoginForm from "./Components/IdentityVerify/loginForm";
import IdentityReport from "./Components/Admin/Pages/IdentityReport";



function App() {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/" element={<HomeIndex />} />
      <Route path="/AttendenceIndex" element={<AttendenceIndex />} />
      <Route path="/AdminLoginIndex" element={<AdminLoginIndex />} />
      <Route path="/BillGeneratorLogin" element={<BillGeneratorLogin />} />
      <Route path="/GenerateBillForm" element={<GenerateBillForm />} />
      <Route path="/Login-Form-identity" element={<LoginForm />} />
      <Route path="/Identity-Verification" element={<IdentityVerification />} />
      {/* <Route path="*" element={<NotFoundPage />} />  <-- Use "*" for a 404 Not Found page */}

      {/* Admin Routes */}
      <Route path="/admin" element={<AdminLayout />}>
        {/* Child routes automatically append to "/admin" */}
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="attendance" element={<Attendance />} />
        <Route path="bills" element={<Bills />} />
        
        // ✅ FIX: Removed "/admin/" from these nested paths
        <Route path="Pending-Bills" element={<PendingBills />} /> 
        <Route path="Pending-Bills-List" element={<PendingBillsList />} /> 
        <Route path="ID-Cards-Generator-DailyGo" element={<IDCards />} />
        <Route path="Identity-Report" element={<IdentityReport />} />

      </Route>
      
    </Routes>
  );
}

export default App;